import { FC, memo } from 'react'
import { Typography } from 'react-components'
import { useTranslation } from '../../../hooks/locale'
import { ComponentSeparator, ExposeSectionTitleWrapper } from '../styles'
import MagicStickIcon from '../../../assets/icons/magic-stick.svg'
import PropertyFeaturesIcon from '../../../assets/icons/property-features.svg'
import FreeCancellationIcon from '../../../assets/icons/free-cancellation.svg'
import MapPinIcon from '../../../assets/icons/map-pin.svg'
import PetIcon from '../../../assets/icons/pet.svg'
import AmmenitiesIcon from '../../../assets/icons/ammenities.svg'
import RatingReviewIcon from '../../../assets/icons/rating-review.svg'
import {
    WhyBookThisHomeWrapper,
    WhyBookThisHomeContentContainer,
    WhyBookThisHomeItem,
    IconWrapper,
    ItemContent,
    ItemTitle,
    ItemDescription,
    AITagWrapper,
} from './styles'
import { WhyBookThisHomeTransport, WhyBookThisHomeCategory } from '../../../transports/property-details-page-transport'

type WhyBookThisHomeProps = {
    whyBookThisHomeObjects?: WhyBookThisHomeTransport[] | null
}

const getIconFromCategoryType = (category?: WhyBookThisHomeCategory | null) => {
    switch (category) {
        case WhyBookThisHomeCategory.SPECIAL_AMENITIES: {
            return AmmenitiesIcon
        }
        case WhyBookThisHomeCategory.CANCELLATION_POLICY: {
            return FreeCancellationIcon
        }
        case WhyBookThisHomeCategory.LOCATION: {
            return MapPinIcon
        }
        case WhyBookThisHomeCategory.PET_FRIENDLY: {
            return PetIcon
        }
        case WhyBookThisHomeCategory.RATINGS: {
            return RatingReviewIcon
        }
        case WhyBookThisHomeCategory.UNIQUE_FEATURES: {
            return PropertyFeaturesIcon
        }
        default: {
            return AmmenitiesIcon
        }
    }
}

const WhyBookThisHome: FC<WhyBookThisHomeProps> = ({ whyBookThisHomeObjects = null }) => {
    const { t } = useTranslation()

    const renderItems = () => (
        <WhyBookThisHomeContentContainer>
            {whyBookThisHomeObjects?.map((item, index) => {
                const IconComponent = getIconFromCategoryType(item?.category)
                return (
                    <WhyBookThisHomeItem key={`${item?.category}-${index}`}>
                        <IconWrapper>
                            <IconComponent />
                        </IconWrapper>
                        <ItemContent>
                            <ItemTitle>{item?.header}</ItemTitle>
                            <ItemDescription>{item?.description}</ItemDescription>
                        </ItemContent>
                    </WhyBookThisHomeItem>
                )
            })}
        </WhyBookThisHomeContentContainer>
    )

    if (!whyBookThisHomeObjects || whyBookThisHomeObjects.length === 0) {
        return null
    }

    return (
        <>
            <WhyBookThisHomeWrapper>
                <AITagWrapper>
                    <MagicStickIcon height={14} width={14} /> {t('createdWithAI')}
                </AITagWrapper>
                <ExposeSectionTitleWrapper>
                    <Typography variant="h6" fontWeight="semiBold" element="h2">
                        {t('whyBookThisHome')}
                    </Typography>
                </ExposeSectionTitleWrapper>

                {renderItems()}
            </WhyBookThisHomeWrapper>
            <ComponentSeparator />
        </>
    )
}

export default memo(WhyBookThisHome)
